






























import Vue from 'vue';

export default Vue.extend({
  name: 'DetailOptionsButton',

  props: {
    buttonClass: {
      type: [String, Array, Object]
    },
    icon: {
      type: String,
      default: 'mdi-dots-horizontal'
    },
    type: {
      type: String
    },
    btnSize: {
      type: [Number, String],
      default: 32
    },
    iconSize: {
      type: [Number, String],
      default: 28
    },
    disabled: {
      type: Boolean
    }
  }
});
